import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class ProductMeasureGroupFilterData {
    measureGroups: Array<DropdownOptionIntegerId>;
}
